import { useEffect, useState } from "react";
import "./orders.css"
import CurrencyFormat from "react-currency-format";
import { FaInfo } from "react-icons/fa6";
import * as shamsi from 'shamsi-date-converter';
import { userorder } from "../../requests/orderRequest";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
function Orders() {
    const user = useAuthUser()
    const [orders, setOrders] = useState([])
    useEffect(async () => {
        try {
            const res = await userorder(user._id)
            setOrders(res)
        } catch (err) {
            console.log(err)
        }
    }, [])
    return (
        <div className="orders">
            <div className="orders-container">
                <table>
                    <thead>
                        <tr>
                            <th>سریال سفارش</th>
                            <th>تاریخ</th>
                            <th>مبلغ</th>
                            <th>جزعیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            orders.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{item._id}</td>
                                        <td>{shamsi.gregorianToJalali(item.createdAt).join('/')}</td>
                                        <td>
                                            <CurrencyFormat
                                                thousandSeparator={true}
                                                value={item.amount}
                                                prefix="تومان"
                                                displayType="text"></CurrencyFormat>
                                        </td>
                                        <td>
                                            <button>
                                                <FaInfo />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                {
                    orders.length == 0 &&
                    <h2>سفارشی ثبت نشده.</h2>
                }
            </div>
        </div>
    )
}

export default Orders;